<template>
  <PaymentBody/>
</template>

<script>
// @ is an alias to /src
import PaymentBody from '@/components/PaymentBody.vue'

export default {
  name: 'PaymentView',
  components: {
    PaymentBody
  }
}
</script>
